module.exports = __webpack_public_path__ + "static/media/crabstick.80aaf241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/crabstick.jpg
// module id = 104
// module chunks = 0